module.exports = __webpack_public_path__ + "cement/img/组 538@2x.bedb8766.png";